// src/data/illustrations.js
//
// Source unique pour toutes les illustrations (galerie du projet
// "Illustrations" + effet Sillage Dessiné en p5.js). Dépose un fichier
// dans src/assets/illustrations/ et il apparaît automatiquement ici,
// quel que soit son nom : Vite scanne le dossier au build, pas besoin
// de lister ou de renommer quoi que ce soit.
const modules = import.meta.glob('../assets/illustrations/*.{jpg,jpeg,png,webp}', {
    eager: true,
    import: 'default'
});

export const illustrations = Object.keys(modules)
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    .map((path) => ({
        src: modules[path],
        alt: 'Illustration de Nathalie Liu'
    }));
